import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useLayoutEffect, useRef, useState } from "react";
import { OverlayGlobalStyle } from "./headerMobile.style";
import Head from "./components/Head/head";
import OverlayMenu from "./components/OverlayMenu/overlayMenu";
var HeaderMobile = function(param) {
    var header = param.header, onTrack = param.onTrack;
    var ref, ref1, ref2, ref3;
    var ref4 = useState(""), isMenuOpen = ref4[0], setIsMenuOpen = ref4[1];
    var containerRef = useRef();
    useLayoutEffect(function() {
        if (containerRef && containerRef.current && header.getContainerHeight) {
            header.getContainerHeight(containerRef.current.clientHeight);
        }
    }, [
        header.getContainerHeight
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isMenuOpen === "fade-in" && /*#__PURE__*/ _jsx(OverlayGlobalStyle, {}),
            /*#__PURE__*/ _jsxs("nav", {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ _jsx(Head, {
                        actionsMenu: header === null || header === void 0 ? void 0 : (ref = header.body) === null || ref === void 0 ? void 0 : ref.actionsMenu,
                        openMenu: setIsMenuOpen,
                        homeRedirect: header === null || header === void 0 ? void 0 : (ref1 = header.body) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.headerLogo) === null || ref2 === void 0 ? void 0 : ref2.url,
                        customerType: (ref3 = header.head) === null || ref3 === void 0 ? void 0 : ref3.customerType
                    }),
                    /*#__PURE__*/ _jsx(OverlayMenu, {
                        onTrack: onTrack,
                        header: header,
                        isMenuOpen: isMenuOpen,
                        setIsMenuOpen: setIsMenuOpen
                    })
                ]
            })
        ]
    });
};
export default HeaderMobile;
